import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import LoadScript from 'vue-plugin-load-script';
import store from '@/store'
import middlewarePipeline from './middlewarePipeline'

import {
    Home,
    Login,
    BillServices,
    ReceiptBillServices,
    ForgetPass,
    Register,
    RegisterWithReferer,
    Verify,
    Logout,
    NamadUser,
    Profile,
    ProfileUpdate,
    ProfileAuthenticate,
    ProfileShebaNumbers,
    ProfileAddresses,
    ProfileChangPassword,
    ProfileNamad,
    GatewayGet,
    //GatewayCreate,
    GatewayUpdate,
    GatewayAllotment,
    GatewayTransactionsReport,

    UserGet,
    UserDetails,
    UserActivityLog,
    ChangeUserPassword,

    GatewayDetails,
    TicketGet,
    TicketCreate,
    TicketComments,
    TransactionGet,
    StoreGet,
    StoreCreate,
    StoreUpdate,
    StoreCoupon,
    StoreCoupons,
    ProductGet,
    ProductCreate,
    ProductUpdate,
    ProductDetails,
    ProductTags,
    ProductDiscounts,
    //PardakhtShakhsiGet,
    PardakhtShakhsiDetails,
    PardakhtShakhsiDirect,
    PardakhtShakhsiCheckout,
    PardakhtShakhsiReceipt,
    NotificationGet,
    NotificationSmsGet,
    RechargeResult,

    VerifyMail,

    SettlementGet,
    SettlementDetails,
    SettlementFiles,
    SettlementVpnLog,

    PaymanGet,
    PaymanCreate,
    PaymanUpdate,
    PaymanDetails,

    IVRCreate,
    IVRUpdate,
    IVRDetails,
    IVRGet,

    DedicatedUpdate,
    DedicatedDetails,
    DedicatedCreate,
    DedicatedGet,
    DedicatedStakeholders,
    DedicatedAllotment,

    MoneyRequestGet,
    MoneyRequestCreate,
    MoneyRequestPay,
    MoneyRequestReceipt,

    StorePage,
    ProductPage,
    AllCart,

    PspRequestGet,
    PspRequestDetails,

    ShaparakRequestsGet,

    MarketingDashboard,
    MarketingTools,
    MarketerSubsets,
    MarketerManaging,
    MarketingSetting,
    SubsetsPSPTransactionsReport,
    SubsetsAppTransactionsReport,
    SubsetsSettlementsReport,

    BlackList,

    GatewaysReports,
    UsersReports,

    AccessDenied,
    NewsGet,
    NewsCreate,
    NewsUpdate,
    ShowNews,

    CollectiveGet,
    CollectiveDetails,
    CollectiveActiveGateways,
    CollectiveCreate,
    CollectiveGatewayDetails,

    OnlineFactorCreateItems,
    OnlineFactorGetItems,
    OnlineFactorShow,
    OnlineFactorCustomers,
    OnlineFactorCreateCustomer,
    OnlineFactorShowCustomer,
    OnlineFactorGetFactor,
    OnlineFactorCreateFactor,
    OnlineFactorShowFactor,
    OnlineFactorPayment,

    UpdateVip,
    CreateVip
} from '@/views'


import PfCreate from '../views/pf/create'

import checkRule from '@/router/middleware/checkRule'


import dashboard from "@/pages/dashboard";
import gateways from "@/pages/gateways/gateways";
import setting from "@/pages/setting/setting"
import transacions from "@/pages/transactions/Get";
import settlements from "@/pages/settlements/Get";
import TransactionDetail from "@/pages/transactions/details"
import tickets from '@/pages/ticket/Get'
import MoneyRequests from '@/pages/money-request/Get'
import TicketDetail from '@/pages/ticket/detail'
import CreateTicket from '@/pages/ticket/create'
import CreateMoneyRequest from '@/pages/money-request/Create'
import ReceiveMoney from '@/pages/receive-money/Get'
import GatewayCreate from '@/pages/gateways/create';
import PardakhtShakhsiGet from '@/pages/setting/pardakht_shakhsi';
import marketingdashboard from '@/pages/marketing/dashboard'
import MarketingSubsets from "@/pages/marketing/Get";
import Markeing_Tools from "@/pages/marketing/marketing-tools";
import posDevice from "@/pages/marketing/posDevice";
import posAcceptor from "@/pages/marketing/components/posAcceptor";
import UserNews from '@/pages/user_news/Get';
import SettlementCreateRequest from '@/pages/settlements/CreateRequest';
import SettlementPspSettlements from '@/pages/settlements/psp-settlements';
import EnamadStatus from "@/pages/enamad/EnamadStatus";
import emtaSuccess from "@/pages/enamad/emtaRedirect/emtaSuccess";
import emtaFailed from "@/pages/enamad/emtaRedirect/emtaFailed";
import CreateCardToCard from "@/pages/card-to-card/Create";
import UpdateCardToCard from "@/pages/card-to-card/Update";
import RechargeCardToCardResult from "@/pages/card-to-card/components/RechargeCardToCardCreditResult.vue";
import RechargeCardToCardWalletResult from "@/pages/card-to-card/components/RechargeCardToCardWalletResult.vue";
import ChargeCardToCardCredit from "@/pages/card-to-card/components/charge-monthly-credit.vue";
import VerifyRegister from '../views/VerifyRegister.vue';


import {
    StakeholdersGet,
    StakeholdersCreate,
    StakeholdersCreateFromUsers,
    StakeholdersCreatePspType,
    StakeholdersUpdate,
    StakeholdersUpdateWalletType,
    StakeholdersUpdatePspType,
    StakeholdersChangeStatus,
    StakeholdersShopsInfo,
    GatewayStakeholdersList,
    GatewayAllotmentList,
} from '@/pages/stakeholders';

import {
    GetWallets,
    ShareholderCreate,
    ShareholderUpdate,
    ShareholderPaginate,

    DayWalletsCreate,
    DayWalletsCharge,
    DayWalletsChargeByOauth,
    DayWalletsChargeByBill,
    DayWalletsTransfer,
    DayWalletsSettlement,
    DayWalletsSettlementDetail,
    DayWalletsTransaction,
    DayWalletsSettlementList,

    AyandeWalletsCreate,
    AyandeWalletsCharge,
    AyandeWalletsChargeByOauth,
    AyandeWalletsChargeByBill,
    AyandeWalletsTransfer,
    AyandeWalletsSettlement,
    AyandeWalletsSettlementDetail,
    AyandeWalletsAutoSettlement,
    AyandeWalletsTransaction,
    AyandeWalletsSettlementList,
    AyandeWalletsPassword,

    WalletCheckStatus,
    GatewayCheckStatus,

    WalletSettlementRecepit,
    WalletSettlementCollectionReceipt
} from '@/pages/wallets';

import {
    GetCard
} from '@/pages/card'

// import {
//     GetPaymnetWithId
// } from '@/pages/payment-id'

import IPGSettlementSettings from "@/pages/gateways/IPGSettlementSettings";
import IVRSettlementSettings from "@/pages/gateways/IVRSettlementSettings";
import NotFound from "@/components/NotFound.vue";
import ShowContract from '@/pages/online-contract/ShowContract.vue';
import SigningGuid from '@/pages/online-contract/SigningGuid.vue';
// import VerifyRegister from '../views/VerifyRegister.vue';
// import ActiveShareholder from '@/pages/wallets/Shareholder/ActiveShareholder.vue';
// import ShareholderLevelVerification from '@/pages/wallets/Shareholder/ShareholderLevelVerification.vue';
// import SubsetsWalletReport from '@/views/marketing/SubsetsWalletReport.vue';
import Create_customer_format from '@/views/online-factor/Create_customer_format.vue';
import CustomerFormats from '@/views/online-factor/CustomerFormats.vue';
import ShowCustomerFormat from '@/views/online-factor/ShowCustomerFormat.vue';
import CreateDiscount from '@/views/online-factor/CreateDiscount.vue';
import Discounts from '@/views/online-factor/Discounts.vue';
import DiscountDetails from '@/views/online-factor/DiscountDetails.vue';

Vue.use(Router);
Vue.use(Meta);
Vue.use(LoadScript);

const defaultBodyClass = "kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-header--fixed kt-header-mobile--fixed kt-subheader--fixed kt-subheader--enabled kt-subheader--solid kt-aside--enabled kt-aside--fixed"

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: dashboard,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/user-news',
            component: UserNews,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/settlement-settings/ipg/:hashid/:type?',
            component: IPGSettlementSettings,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/settlement-settings/vip/:hashid',
            component: IVRSettlementSettings,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        // {
        //     path: '/login',
        //     component: Login,
        // },
        {
            path: '/forget-pass',
            component: ForgetPass
        },
        {
            path: '/logout',
            component: Logout
        },
        {
            path: '/register',
            component: Register
        },
        {
            path: '/login',
            component: Login
        },
        {
            path: '/login/:token/:user',
            component: Login
        },
        {
            path: '/bill-services',
            component: BillServices
        },
        {
            path: '/bill-services/receipt/:order_id',
            component: ReceiptBillServices
        },
        {
            path: '/register/:referer_id?',
            component: RegisterWithReferer
        },
        {
            path: '/namad/:gateway_id',
            component: NamadUser
        },
        {
            path: '/marketing/dashboard',
            name: 'dashboard',
            component: marketingdashboard,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/marketing/subsets',
            name: 'dashboard',
            component: MarketingSubsets,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        // {
        //     path: '/pos/acceptor',
        //     name: 'posDevice',
        //     component: posDevice,
        //     meta: {
        //         bodyClass: defaultBodyClass,
        //     },
        // },
        {
            path: '/pos/subsets/acceptor',
            name: 'posAcceptor',
            component: posAcceptor,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/marketing/tools',
            name: 'marketing_tools',
            component: Markeing_Tools,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/marketing/:user_id/subsets',
            name: 'marketing_subsets',
            component: MarketerSubsets,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/marketing/:user_id/actions',
            name: 'marketer_managing',
            component: MarketerManaging,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/marketing/:user_id/subset-psp-transactions-report',
            name: 'subset_transactions_report',
            component: SubsetsPSPTransactionsReport,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/marketing/:user_id/subset-app-transactions-report',
            name: 'subset_transactions_report',
            component: SubsetsAppTransactionsReport,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/marketing/setting',
            name: 'marketing_setting',
            component: MarketingSetting,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/marketing/subsets-settlements',
            name: 'subsets_settlements_report',
            component: SubsetsSettlementsReport,
            meta: {
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/wallets',
            name: 'get_wallets',
            component: GetWallets,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/day-wallets/create',
            name: 'day_wallets_create',
            component: DayWalletsCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/day-wallets/charge/:hashid',
            name: 'day_wallets_charge',
            component: DayWalletsCharge,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/day-wallets/charge-by-oauth/:hashid',
            name: 'day_wallets_charge_by_oauth',
            component: DayWalletsChargeByOauth,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/day-wallets/transfer/:hashid',
            name: 'day_wallets_transfer',
            component: DayWalletsTransfer,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/day-wallets/settlement/:hashid',
            name: 'day_wallets_settlement',
            component: DayWalletsSettlement,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/day-wallets/settlement-detail/:hashid',
            name: 'day_wallets_settlement_detail',
            component: DayWalletsSettlementDetail,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/day-wallets/transaction/:hashid',
            name: 'day_wallets_transaction',
            component: DayWalletsTransaction,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/day-wallets/settlement-list/:hashid',
            name: 'day_wallets_settlement_list',
            component: DayWalletsSettlementList,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/wallets/create',
            name: 'ayande_wallets_create',
            component: AyandeWalletsCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        // {
        //     path: '/wallets/charge/:hashid',
        //     name: 'ayande_wallets_charge',
        //     component: AyandeWalletsCharge,
        //     meta: {
        //         requiresAuth: true,
        //         bodyClass: defaultBodyClass,
        //     },
        // },
        {
            path: '/wallets/charge-by-oauth/:hashid',
            name: 'ayande_wallets_charge_by_oauth',
            component: AyandeWalletsChargeByOauth,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/charge-by-bill/:hashid',
            name: 'ayande_wallets_charge_by_bill',
            component: AyandeWalletsChargeByBill,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/transfer/:hashid',
            name: 'ayande_wallets_transfer',
            component: AyandeWalletsTransfer,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/settlement/:hashid',
            name: 'ayande_wallets_settlement',
            component: AyandeWalletsSettlement,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/settlement-detail/:hashid',
            name: 'ayande_wallets_settlement_detail',
            component: AyandeWalletsSettlementDetail,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/transaction/:hashid',
            name: 'ayande_wallets_transaction',
            component: AyandeWalletsTransaction,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/settlement-list/:hashid?',
            name: 'ayande_wallets_settlement_list',
            component: AyandeWalletsSettlementList,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/auto-settlement/:hashid',
            name: 'ayande_wallets_auto_settlement',
            component: AyandeWalletsAutoSettlement,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/password/:hashid',
            name: 'ayande_wallets_password',
            component: AyandeWalletsPassword,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/status/:id/wallet',
            name: 'wallet_check_status',
            component: WalletCheckStatus,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/status/:id/dargah',
            name: 'gateway_check_status',
            component: GatewayCheckStatus,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/settlement-receipt/:id',
            name: 'wallet_settlement_receipt',
            component: WalletSettlementRecepit,
            meta: {
                requiresAuth: false,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/wallets/settlement-receipt/collection/:hashid',
            name: 'wallet_settlement_collection_receipt',
            component: WalletSettlementCollectionReceipt,
            props: true,
            meta: {
                requiresAuth: false,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/shareholder/create',
            name: 'shareholder-create',
            component: ShareholderCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/shareholder/update/:hashid',
            name: 'shareholder-update',
            component: ShareholderUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/shareholders',
            name: 'shareholder-paginate',
            component: ShareholderPaginate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        // {
        //     path: '/payment-id',
        //     name: 'PaymentWithid',
        //     component: GetPaymnetWithId,
        //     meta: {
        //         requiresAuth: true,
        //         bodyClass: defaultBodyClass,
        //     },
        // },
        {
            path: '/enamad-result/:id',
            name: 'enamdPayment',
            component: EnamadStatus,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        // emta redirect
        {
            path: '/enamad-success/:shop_id',
            name: 'emtaSuccess',
            component: emtaSuccess,
            meta: {
                requiresAuth: false,
                bodyClass: ''
            }
        },
        {
            path: '/enamad-failed/:shop_id',
            name: 'emtaFailed',
            component: emtaFailed,
            meta: {
                requiresAuth: false,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/card',
            name: 'card',
            component: GetCard,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/verify',
            component: Verify
        },

        {
            path: '/verifyRegister',
            component: VerifyRegister
        },

        {
            path: '/profile',
            component: Profile,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/profile/update',
            component: ProfileUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/profile/authenticate',
            component: ProfileAuthenticate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/profile/sheba-numbers',
            component: ProfileShebaNumbers,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/profile/addresses',
            component: ProfileAddresses,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/profile/change-password',
            component: ProfileChangPassword,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/profile/namad/:gateway_id',
            component: ProfileNamad,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/gateways',
            name: 'gateways',
            component: gateways,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/gateways/create',
            name: 'gateways_create',
            component: GatewayCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/gateways/update/:hashid/:tab?',
            name: 'gateways_update',
            component: GatewayUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/gateways/gateway-form/:hashid/:tab?',
            name: 'gateways_update',
            component: GatewayUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/gateways/:hashid/details',
            name: 'gateways_details',
            component: GatewayDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [],
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        // pf
        {
            path: '/pf/create',
            name: 'pf_create',
            component: PfCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/gateways/transactions-report/:hashid',
            name: 'gateway_transactions_report',
            component: GatewayTransactionsReport,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/psp-request',
            name: 'psp_request_get',
            component: PspRequestGet,
            meta: {
                requiresAuth: true,
                rules: {
                    gateway: ['manage']
                },
                middleware: [],
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/psp-request/:hashid/details',
            name: 'psp_request_details',
            component: PspRequestDetails,
            meta: {
                requiresAuth: true,
                rules: {
                    gateway: ['manage']
                },
                middleware: [],
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/shaparak-requests',
            name: 'shaparak_requests_get',
            component: ShaparakRequestsGet,
            meta: {
                requiresAuth: true,
                rules: {
                    gateway: ['manage']
                },
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/news',
            name: 'news',
            component: NewsGet,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [],
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/news/create',
            name: 'news_create',
            component: NewsCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/news/update/:hashid',
            name: 'News_Update',
            component: NewsUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/news/see/:newsid',
            name: 'NewsSee',
            component: UserGet,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [],
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/news/:newsid',
            name: 'See',
            component: ShowNews,
            meta: {
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/users',
            name: 'users',
            component: UserGet,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [],
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/users/:hashid/details',
            name: 'users_details',
            component: UserDetails,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [],
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/users/:hashid/activities-logs',
            name: 'user_activity_log',
            component: UserActivityLog,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [],
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/users/:hashid/change-password',
            name: 'change_user_password',
            component: ChangeUserPassword,
            meta: {
                requiresAuth: true,
                rules: {
                    user: ['manage']
                },
                middleware: [],
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/stakeholders',
            name: 'stakeholders_get',
            component: StakeholdersGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stakeholders/create',
            name: 'stakeholders_create',
            component: StakeholdersCreate,
            redirect: '/stakeholders/create-from-users',
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stakeholders/create-from-users',
            name: 'stakeholders_create_from_users',
            component: StakeholdersCreateFromUsers,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stakeholders/create-psp-type',
            name: 'stakeholders_create_psp_type',
            component: StakeholdersCreatePspType,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stakeholders/update/:hashid',
            name: 'stakeholders_update',
            component: StakeholdersUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stakeholders/update-wallet-type/:hashid',
            name: 'stakeholders_update_wallet_type',
            component: StakeholdersUpdateWalletType,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stakeholders/update-psp-type/:hashid',
            name: 'stakeholders_update_psp_type',
            component: StakeholdersUpdatePspType,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stakeholders/change-status/:hashid',
            name: 'stakeholders_change_status',
            component: StakeholdersChangeStatus,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stakeholders/shops-info/:hashid',
            name: 'stakeholders_shops_info',
            component: StakeholdersShopsInfo,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/gateways/stakeholders/:hashid',
            name: 'gateway_stakeholders_list',
            component: GatewayStakeholdersList,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/gateways/:hashid/allotment',
            name: 'gateways_allotment',
            component: GatewayAllotmentList,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/dedicated/stakeholders/:hashid',
            name: 'dedicated_stakeholders_list',
            component: DedicatedStakeholders,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/dedicated/:hashid/allotment',
            name: 'dedicated_allotment',
            component: DedicatedAllotment,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/tickets',
            name: 'tickets',
            component: tickets,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/tickets/create',
            name: 'tickets_create',
            //component: TicketCreate,
            component: CreateTicket,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/tickets/:hashid/comments',
            name: 'tickets_comments',
            //component: TicketComments,
            component: TicketDetail,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/transactions/:tab?',
            name: 'transactions',
            component: transacions,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        // {
        //     path: '/money-request/:type?',
        //     name: 'money-request',
        //     component:MoneyRequests,
        //     meta: {
        //         requiresAuth: true,
        //         bodyClass: defaultBodyClass,
        //     }
        // },
        {
            path: '/receive-money',
            name: 'receive-money',
            component: ReceiveMoney,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/money-request-create/:type?',
            name: 'money-request-create',
            //component: MoneyRequestCreate,
            component: CreateMoneyRequest,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/pay/:tracking_code',
            name: 'money-request-pay',
            component: MoneyRequestPay,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/money-request-receipt/:tracking_code',
            name: 'money-request-receipt',
            component: MoneyRequestReceipt,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/online-factor-item-create/:create?',
            name: 'online-factor-create',
            component: OnlineFactorCreateItems,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/online-factor-factor-create',
            name: 'online-factor-factor-create',
            component: OnlineFactorCreateFactor,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/online-factor/create-discount',
            name: 'online-factor-discount-create',
            component: CreateDiscount,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/online-factor/discounts',
            name: 'online-factor-discount-index',
            component: Discounts,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/online-factor/discounts/:hashid/details',
            name: 'online-factor-discount-detail',
            component: DiscountDetails,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/online-factor-customer-create/:create?',
            name: 'online-factor-create',
            component: OnlineFactorCreateCustomer,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/online-factor-customer-format-create',
            name: 'online-factor-create',
            component: Create_customer_format,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/factors',
            name: 'online-factor-factor',
            component: OnlineFactorGetFactor,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/items',
            name: 'online-factor-item',
            component: OnlineFactorGetItems,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/customers',
            name: 'online-factor-customers',
            component: OnlineFactorCustomers,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/customer-formats',
            name: 'online-factor-customer-formats',
            component: CustomerFormats,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/items/:hashid/details',
            name: 'online-factor-show-item',
            component: OnlineFactorShow,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/customers/:hashid/details',
            name: 'online-factor-show-customer',
            component: OnlineFactorShowCustomer,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/customer-formats/:hashid/details',
            name: 'online-factor-show-customer',
            component: ShowCustomerFormat,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/factor/:hashid/details',
            name: 'online-factor-show-factor',
            component: OnlineFactorShowFactor,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/invoice/:hashid/sub-factor/:subFactorId?',
            name: 'online-factor-pay-factor',
            component: OnlineFactorPayment,
            meta: {
                requiresAuth: false,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores',
            name: 'stores',
            component: StoreGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores/create',
            name: 'stores_create',
            component: StoreCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores/update/:hashid',
            name: 'stores_update',
            component: StoreUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores/:store_hashid/coupons/create',
            name: 'store_coupon',
            component: StoreCoupon,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores/:store_hashid/coupons',
            name: 'stores_coupon',
            component: StoreCoupons,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores/:store_hashid/products',
            name: 'products',
            component: ProductGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores/:store_hashid/products/create',
            name: 'products_create',
            component: ProductCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores/:store_hashid/products/update/:hashid',
            name: 'products_update',
            component: ProductUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores/:store_hashid/products/details/:hashid',
            name: 'products_details',
            component: ProductDetails,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores/:store_hashid/products/tag/:hashid',
            name: 'products_tags',
            component: ProductTags,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/stores/:store_hashid/products/discount/:hashid',
            name: 'products_discount',
            component: ProductDiscounts,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        /**
         * Settlement
         */
        {
            path: '/settlements',
            name: 'settlements',
            component: settlements,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/settlements/:hashid/details',
            name: 'settlements_details',
            component: SettlementDetails,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
                rules: {
                    transaction: ['manage']
                },
                middleware: []
            }
        },
        {
            path: '/settlements/vpn-log',
            name: 'settlements_vpn_log',
            component: SettlementVpnLog,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
                rules: {
                    transaction: ['manage']
                },
                middleware: []
            }
        },
        {
            path: '/settlements/files',
            name: 'settlements_files',
            component: SettlementFiles,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass,
                rules: {
                    transaction: ['manage']
                },
                middleware: []
            }
        },

        {
            path: '/settlements/create-request',
            name: 'settlements_create_request',
            component: SettlementCreateRequest,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/settlements/psp-settlements',
            name: 'settlements_psp_settlements',
            component: SettlementPspSettlements,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        /**
         * Payman
         */
        {
            path: '/payman',
            name: 'payman',
            component: PaymanGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/payman/create',
            name: 'payman_create',
            component: PaymanCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/payman/update/:hashid',
            name: 'payman_update',
            component: PaymanUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/payman/:hashid/details',
            name: 'payman_details',
            component: PaymanDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [],
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        //* Special */
        {
            path: '/create-vip',
            name: 'create_vip',
            component: CreateVip,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/update-vip/:hashid',
            name: 'update_vip',
            props: true,
            component: UpdateVip,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        /**
         * IVR
         */
        {
            path: '/ivr/create',
            name: 'ivr_create',
            component: IVRCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/ivr/update/:hashid',
            name: 'ivr_update',
            component: IVRUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/ivr/:hashid/details',
            name: 'ivr_details',
            component: IVRDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [],
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/ivr',
            name: 'ivr',
            component: IVRGet,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [],
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        /**
         * Dedicated
         */
        {
            path: '/dedicated/create',
            name: 'dedicated_create',
            component: DedicatedCreate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/dedicated/update/:hashid',
            name: 'dedicated_update',
            component: DedicatedUpdate,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/dedicated/:hashid/details',
            name: 'dedicated_details',
            component: DedicatedDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [],
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/dedicated',
            name: 'dedicated',
            component: DedicatedGet,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                middleware: [],
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        // /**
        //  * Pardakht Shakhsi
        //  */
        {
            path: '/pardakht-shakhsi',
            name: 'pardakht_shakhsi',
            component: PardakhtShakhsiGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/pardakht-shakhsi/:hashid/details',
            name: 'pardakht_shakhsi_details',
            component: PardakhtShakhsiDetails,
            meta: {
                rules: {
                    pardakht_shakhsi: ['manage']
                },
                middleware: [],
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        // Collective Gateways
        {
            path: '/collective',
            name: 'collective_get',
            component: CollectiveGet,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/collective/create',
            name: 'collective_create',
            component: CollectiveCreate,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/collective/:hashid/details',
            name: 'collective_details',
            component: CollectiveDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/collective/gateway/:hashid/details',
            name: 'collective_gateway_details',
            component: CollectiveGatewayDetails,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/collective/active-gateways',
            name: 'active_gateways',
            component: CollectiveActiveGateways,
            meta: {
                rules: {
                    gateway: ['manage']
                },
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        // Notification
        {
            path: '/notification-email',
            name: 'notification_settings',
            component: NotificationGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        ///Notification Sms
        {
            path: '/notification-sms',
            name: 'notification_sms_settings',
            component: NotificationSmsGet,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/notification-sms/recharge-result/:tracking_code',
            name: 'recharge-result',
            component: RechargeResult,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/security/black-list',
            name: 'security-black-list',
            component: BlackList,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/reports/gateways',
            name: 'gateways-reports',
            component: GatewaysReports,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/reports/users',
            name: 'reports-users',
            component: UsersReports,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        // Public access pages
        {
            path: '/@:store',
            name: 'store_page',
            component: StorePage,
            meta: {
                requiresAuth: false,
                bodyClass: ''
            }
        },
        {
            path: '/@:store/:product_hashid',
            name: 'product_page',
            component: ProductPage,
            meta: {
                requiresAuth: false,
                bodyClass: ''
            }
        },
        {
            path: '/cart/@:store',
            name: 'cart_page',
            component: AllCart,
            meta: {
                requiresAuth: false,
                bodyClass: ''
            }
        },

        {
            path: '/d/@:username',
            name: 'direct_pay',
            component: PardakhtShakhsiDirect,
            meta: {
                requiresAuth: false,
                bodyClass: 'body'
            }
        },
        {
            path: '/d/@:username/:price',
            name: 'direct_pay',
            component: PardakhtShakhsiDirect,
            meta: {
                requiresAuth: false,
                bodyClass: 'body'
            }
        },
        {
            path: '/pay/:tracking_code',
            name: 'direct_checkout',
            component: PardakhtShakhsiCheckout,
            meta: {
                requiresAuth: false,
                bodyClass: 'body'
            }
        },
        {
            path: '/receipt/:tracking_code',
            name: 'direct_receipt',
            component: PardakhtShakhsiReceipt,
            meta: {
                requiresAuth: false,
                bodyClass: 'body'
            }
        },

        // Email Verification
        {
            path: '/verify-mail/:tracking_code',
            name: 'verify_mail',
            component: VerifyMail,
            meta: {
                requiresAuth: false,
                bodyClass: 'body'
            }
        },

        {
            path: '/access-denied',
            name: 'access_denied',
            component: AccessDenied,
            meta: {
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/user-setting',
            name: 'user-setting',
            component: setting,
            meta: {
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/user-setting/:tabslug',
            name: 'user-setting',
            component: setting,
            meta: {
                bodyClass: defaultBodyClass
            }
        },

        {
            path: '/transactions/:hashid/details',
            name: 'transaction_detail',
            component: TransactionDetail,
            meta: {
                bodyClass: defaultBodyClass
            }
        },

        //cardToCArd
        {
            path: '/card-to-card/create',
            name: 'create_card_to_card',
            component: CreateCardToCard,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/card-to-card/update/:hashid',
            name: 'update_card_to_card',
            component: UpdateCardToCard,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/card-to-card/gateway/recharge-result/:tracking_code',
            name: 'recharge_card_to_card_credit_result',
            component: RechargeCardToCardResult,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/card-to-card/gateway/recharge-wallet-result/:tracking_code',
            name: 'recharge_card_to_card_wallet_result',
            component: RechargeCardToCardWalletResult,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/online-contract/signing-guid',
            name: 'signing_guid',
            component: SigningGuid,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },
        {
            path: '/online-contract/:hashid',
            name: 'show_contract',
            component: ShowContract,
            meta: {
                requiresAuth: true,
                bodyClass: defaultBodyClass
            }
        },

        //Not Found
        { path: '/:pathMatch(.*)*', component: NotFound },

        /* Catch Alls */
        { path: '', redirect: '/login' }
    ]
});

router.beforeEach(async (to, from, next) => {
    // check if current user is null, fecth it
    if (!store.getters['user/is_current_user_fetched'] && !['/login', '/register', '/forget-pass'].includes(to.path)) {
        store.dispatch('user/fetchCurrent')
    }

    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters['auth/isLoggedIn']) {
            next('/login')
            return
        }

        let currentTimeStamp = Math.floor(Date.now() / 1000)
        let exp_token = localStorage.getItem('exp_token')

        if (exp_token && exp_token < currentTimeStamp){
            localStorage.removeItem('user')
            localStorage.removeItem('access_token')
            localStorage.removeItem('exp_token')
            next('/login')
            return
        }
    }

    if (!to.meta.middleware || to.meta.middleware.length === 0) {
        return next()
    }
    const middleware = to.meta.middleware

    const context = {
        to,
        from,
        next,
        store
    }

    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    })
})

export default router;